import { DraftOrderItemDetails } from "./DraftOrderDetails";
import { emptyDraft } from "../model";
const draft=emptyDraft();

export const OrderItemDetailsPlaceholder=() => <DraftOrderItemDetails draft={draft} accounts={[]} options={[]} baseName="-" />;
